import React, { useCallback, useState } from "react";
import Ansi from "ansi-to-react";
import { VscDebugAlt } from "react-icons/vsc";

const BlockOutput = (props) => {
  // const outputs = props.cell['outputs'];
  const outputs = props.outputs;
  const cellIndex = props.cellIndex;
  console.log("Rendering output ", cellIndex);
  const debugOutputError = props.debugOutputError;

  const [state, setState] = useState({
    highlighted: false,
    prevDisplay: 1,
    display: 1,
    contentHeight: 0,
    outputFormat: 0, // 0-> collapsed, 2-> expand, 1-> scrollable
  })
  const onChangeOutputFormat = (val) => {
    setState(state => ({ ...state, outputFormat: val }));
  }
  const contentRef = useCallback((node) => {
    if (node) {
      setState(state => ({ ...state, contentHeight: node.offsetHeight }));
    }
  }, [props])


  return (
    <div
      className="block-output"

    >
      {/* <div
        className={props.highlighted ? "block-light-selected" : "block-light"}
      // onClick={() => {
      //   setState({ ...state, display: (state.display + 1) % 3 })
      // }}
      /> */}
      {state.display === 0 ? <div className="block-hidden" /> :
        <>
          <div
            className="block-output-content custom-scrollbar"
          >
            <div className="custom-scrollbar" style={state.outputFormat === 0 ? { maxHeight: "400px", overflowY: "hidden" } :
              state.outputFormat === 1 ? { maxHeight: "400px", overflowY: "auto" } : {}}>
              <div ref={contentRef} >
                {!outputs ? null : outputs.map((output, index) => {
                  let executionCount;
                  let htmlContent;
                  let outputError = "";
                  if ('output_type' in output) {
                    let output_type = output['output_type'];
                    switch (output_type) {
                      // Stdout and stderr
                      case 'stream':
                        htmlContent = (
                          <pre className={`cell-content ${output['name'] === 'stdout' ? 'output-std' : 'output-err'}`}>
                            {!output['text'] ? '' : output['text'].join('')}
                          </pre>
                        )
                        // if (output['name'] === 'stderr') {
                        //   outputError = output['text'].join('');
                        // }

                        break;
                      // Output with execution_count
                      // @ts-expect-error
                      case 'execute_result':
                        executionCount = output['execution_count']
                      // Output without execution_count
                      case 'display_data':
                        const output_data = output['data'];
                        if (output_data) {
                          if ('image/png' in output_data) {
                            let output_metadata = output['metadata'];
                            let size = output_metadata && output_metadata['image/png'];
                            htmlContent = (
                              <div
                                className="cell-content output-display"
                                style={{
                                  justifyContent: props.mediaAlign,
                                }}
                              >
                                <img
                                  src={`data:image/png;base64,${output_data['image/png']}`}
                                  width={size ? size['width'] : 'auto'}
                                  height={size ? size['height'] : 'auto'}
                                  alt=""
                                />
                              </div>
                            )
                          }
                          else if ('text/html' in output_data) {
                            htmlContent = (
                              <div
                                className="cell-content output-display"
                                style={{
                                  justifyContent: props.mediaAlign,
                                }}
                                dangerouslySetInnerHTML={{ __html: output_data['text/html'].join('') }}
                              />
                            )
                          }
                          else if ('text/plain' in output_data) {
                            htmlContent = (
                              <pre className="cell-content output-std">{output_data['text/plain'].join('')}</pre>
                            )
                          }
                        }

                        break;
                      // Exceptions
                      case 'error':
                        htmlContent = (
                          <pre className="cell-content output-err">
                            <Ansi>
                              {!output.traceback ? undefined : output.traceback.join('\n')}
                            </Ansi>
                          </pre>
                        )
                        outputError = output.traceback.join('\n');

                        break;
                      default:
                        console.log('Unexpected output_type: ', output_type);
                    }
                  }
                  // console.log(outputError);
                  return (
                    <div
                      key={index}
                      className="cell-row"
                    >
                      {/* <pre className="cell-header output">header</pre> */}
                      <div className="output-debug-button-div">
                        {outputError !== "" &&
                          <button title="debug" className="output-debug-button" onClick={() => { debugOutputError(cellIndex, outputError) }}> <VscDebugAlt className="icons-sizes-runcode" /></button>
                        }
                      </div>
                      {htmlContent}

                    </div>
                  );
                })}
              </div>
            </div>
            {state.contentHeight > 350 && state.outputFormat === 0 && <>
              <div className="truncation-message">
                <span>Output is truncated.</span>
                <a onClick={() => { onChangeOutputFormat(2) }} aria-label="enable expand output">  Expand Output </a>
                <span>or View as a </span>
                <a onClick={() => { onChangeOutputFormat(1) }} aria-label="enable scrollable output"> scrollable element</a>
                <span>...</span></div>
            </>}
          </div>
        </>
      }
    </div>
  )
}

export default React.memo(BlockOutput);